export default __webpack_public_path__ + "static/media/img05.2b83c395.png";